<app-enfaf-modal
  svgIcon="award-black"
  [title]="'Enviar y expedir diploma'"
  subtitle="El diploma correspondiente al curso se expedirá con el nombre del alumno y se le enviará al correo."
  [buttonCancelText]="'Cancelar'"
  [buttonConfirmText]="'Confirmar y enviar'"
  [isLoading]="isSending"
  [showCloseButton]="true"
  [showContent]="false"
  (onConfirm)="onConfirm()"
  (onClose)="onClose()"
>
</app-enfaf-modal>
